import { render, staticRenderFns } from "./OwnOrder.vue?vue&type=template&id=761160ce&scoped=true"
import script from "./OwnOrder.vue?vue&type=script&lang=js"
export * from "./OwnOrder.vue?vue&type=script&lang=js"
import style0 from "./OwnOrder.vue?vue&type=style&index=0&id=761160ce&prod&scoped=true&lang=css"
import style1 from "./OwnOrder.vue?vue&type=style&index=1&id=761160ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761160ce",
  null
  
)

export default component.exports